import ConfigurableListTemplate from './ConfigurableListTemplate'

export default ConfigurableListTemplate
